import { Identifier } from "react-admin";
import { Context, createContext } from "react";

export interface IHoverContext {
  hoveredEventId?: Identifier;
  onHover?: (id: Identifier | undefined) => void;
}

export const EventHoverContext: Context<IHoverContext> = createContext({});
